import lozad from 'lozad';

class LazyImages
{
    static load() {
        lozad(document.querySelectorAll('img[data-src]:not([data-loaded])')).observe();
    }
}

export {LazyImages};
